<template>
  <d-input-group seamless>
    <d-input v-model="d_value" :placeholder="placeholder" :type="d_showPassword ? 'text' : 'password'" />

    <d-input-group-addon append>
      <div @click="d_showPassword = !d_showPassword" class="input-group-icon cursor-pointer">
        <i class="fas" :class="!d_showPassword ? 'fa-eye' : 'fa-eye-slash'" />
      </div>
    </d-input-group-addon>
  </d-input-group>
</template>

<script>
export default {
  name: 'form-password-input',
  props: {
    placeholder: String,
    value: String,
  },
  data () {
    return {
      d_showPassword: false,
      d_value: this.value,
    };
  },
  watch: {
    d_value () {
      this.$emit('input', this.d_value);
    },
    value (value) {
      this.d_value = value;
    },
  },
}
</script>
